import React from "react";
import { Column } from "simple-flexbox";
import { css } from "aphrodite";
import { NavLink } from "react-router-dom";
import MenuItemComponent from "./MenuItemComponent";
import IconDashboard from "../../assets/icon-dashboard";
import IconMail from "../../assets/icon-mail";
import IconSchool from "../../assets/icon-school";
import IconAccountCircle from "../../assets/icon-account-circle";
import AddBoxIcon from "../../assets/icon-plus";
import PeopleIcon from "../../assets/icon-people";
import RecordVoiceOverIcon from "../../assets/icon-record-people";
import StarsIcon from "../../assets/icon-star";
import SupportIcon from "../../assets/icon-support";
import PaymentIcon from "../../assets/icon-payment";
import DeviceIcon from "../../assets/icon-device";
import EventIcon from "../../assets/icon-event";
import ChampIcon from "../../assets/icon-champ";
import PreferenceIcon from "../../assets/icon-room-preferences";
import ComputerIcon from "../../assets/icon-computer";
import DocumentIcon from "../../assets/icon-document";
import PeopleAddIcon from "../../assets/icon-people-add";
import MonetizationIcon from "../../assets/icon-monetization";
import AccountBalanceIcon from "../../assets/icon-account-balance";
import RedeemIcon from "../../assets/icon-redeem";
import MailIcon from "../../assets/icon-mail";
import AdsIcon from "../../assets/icon-ads";
import IconSetting from "../../assets/icon-setting";
import IconJobspot from "../../assets/icon-jobspot";

export default function SidebarMenu({
  role,
  isPaidDues,
  selectedItem,
  onItemClicked,
  styles,
}) {
  return (
                <Column className={css(styles.menuItemList)}>
                  {/* {  ini admin kolegium} */}
                  {role === "admin_kolegium" && (
                    <>
                      <NavLink
                        to="/dashboard-admin-kolegium"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Dashboard"
                          icon={IconDashboard}
                          onClick={() =>
                            onItemClicked("Dashboard", "dashboard")
                          }
                          active={selectedItem === "Dashboard"}
                        />
                      </NavLink>
                      <NavLink
                        to="/registrasi"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Registrasi SP 1"
                          icon={PeopleAddIcon}
                          onClick={() => onItemClicked("Registrasi SP 1")}
                          active={selectedItem === "Registrasi SP 1"}
                        />
                      </NavLink>
                      <NavLink
                        to="/registrasi-sp2"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Registrasi SP 2"
                          icon={PeopleAddIcon}
                          onClick={() => onItemClicked("Registrasi SP 2")}
                          active={selectedItem === "Registrasi SP 2"}
                        />
                      </NavLink>
                      <NavLink to="/ppds" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="PPDS 1"
                          icon={IconSchool}
                          onClick={() => onItemClicked("PPDS")}
                          active={selectedItem === "PPDS"}
                        />
                      </NavLink>
                      <NavLink to="/ppds-sp2" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="SP 2"
                          icon={IconSchool}
                          onClick={() => onItemClicked("SP 2")}
                          active={selectedItem === "SP 2"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Member"
                        icon={IconAccountCircle}
                        onClick={() => onItemClicked("Member")}
                        active={selectedItem === "Member"}
                        child={[
                          {
                            icon: PeopleIcon,
                            title: "Profil",
                            link: "/member",
                          },
                          {
                            icon: IconSchool,
                            title: "Pendidikan",
                            link: "/admin/member-education",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Serkom",
                            link: "/member/serkom",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: AddBoxIcon,
                            title: "Serkom",
                            link: "/admin/serkom",
                          },
                        ]}
                      />
                      {/* <NavLink
                        to="/final-paper"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="CMS Final Paper"
                          icon={DocumentIcon}
                          onClick={() => onItemClicked("CMS Final Paper")}
                          active={selectedItem === "CMS Final Paper"}
                        />
                      </NavLink> */}
                    </>
                  )}
                  {/* </NavLink> */}
                  {role === "member" && isPaidDues && (
                    <>
                      <MenuItemComponent
                        title="Member"
                        icon={IconAccountCircle}
                        onClick={() => onItemClicked("Member")}
                        active={selectedItem === "Member"}
                        child={[
                          {
                            icon: IconAccountCircle,
                            title: "Profile",
                            link: "/member/member-profile/pengantar",
                          },
                          {
                            icon: IconSchool,
                            title: "Pendidikan",
                            link: "/education",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Tempat Praktik",
                            link: "/practice",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "Pelatihan",
                            link: "/training",
                          },
                          {
                            icon: PeopleIcon,
                            title: "Pengalaman",
                            link: "/experience",
                          },
                          {
                            icon: StarsIcon,
                            title: "Penghargaan",
                            link: "/member/member-appreciation",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: IconSchool,
                            title: "SKP",
                            link: "/skp",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Serkom",
                            link: "/serkom",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR",
                            link: "/str",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR KT",
                            link: "/strkt",
                          },
                          {
                            icon: PeopleIcon,
                            title: "SIP",
                            link: "/sip",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="Trans/ Mutasi"
                        icon={PeopleAddIcon}
                        onClick={() => onItemClicked("Trans/ Mutasi")}
                        active={selectedItem === "Trans/ Mutasi"}
                        child={[
                          {
                            icon: PeopleAddIcon,
                            title: "Mutasi Anggota",
                            link: "/member/mutation",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Trans RS",
                            link: "/transrs",
                          },
                        ]}
                      />
                      <NavLink
                        to="/pengajuan-sip"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Rekom SIP"
                          icon={IconMail}
                          onClick={() => onItemClicked("Rekom SIP")}
                          active={selectedItem === "Rekom SIP"}
                        />
                      </NavLink>
                      <NavLink to="/support" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Perlindungan Hukum"
                          icon={SupportIcon}
                          onClick={() => onItemClicked("Support")}
                          active={selectedItem === "Support"}
                        />
                      </NavLink>
                      <NavLink to="/benefit" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Benefit"
                          icon={RedeemIcon}
                          onClick={() => onItemClicked("Benefit")}
                          active={selectedItem === "Benefit"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Report"
                        icon={DocumentIcon}
                        onClick={() => onItemClicked("Report")}
                        active={selectedItem === "Report"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Iuran Paboi",
                            link: "/member/iuran",
                          },
                          {
                            icon: AccountBalanceIcon,
                            title: "Koperasi",
                            link: "/koperasi",
                          },
                        ]}
                      />
                    </>
                  )}
                   {role === "member" && !isPaidDues && (
                    <>
                      <MenuItemComponent
                        title="Member"
                        icon={IconAccountCircle}
                        onClick={() => onItemClicked("Member")}
                        active={selectedItem === "Member"}
                        child={[
                          {
                            icon: IconAccountCircle,
                            title: "Profile",
                            link: "/member/member-profile/pengantar",
                          },
                        ]}
                      />
                    </>
                  )}
                  {role === "root" && (
                    <>
                      <NavLink
                        to="/dashboard-admin-pusat"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Dashboard"
                          icon={IconDashboard}
                          onClick={() =>
                            onItemClicked("Dashboard", "dashboard")
                          }
                          active={selectedItem === "Dashboard"}
                        />
                      </NavLink>
                      <NavLink
                          to="/registrasi-member"
                          exact
                          className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                            title="Registrasi Member"
                            icon={IconSetting}
                            onClick={() =>
                                onItemClicked("Registrasi Member")
                            }
                            active={selectedItem === "Registrasi Member"}
                        />
                      </NavLink>
                      <NavLink
                          to="/jobspot"
                          exact
                          className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                            title="Jobspot"
                            icon={IconJobspot}
                            onClick={() =>
                                onItemClicked("JobSpot")
                            }
                            active={selectedItem === "JobSpot"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Member"
                        icon={IconAccountCircle}
                        onClick={() => onItemClicked("Member")}
                        active={selectedItem === "Member"}
                        child={[
                          {
                            icon: PeopleIcon,
                            title: "Profil",
                            link: "/member",
                          },
                          {
                            icon: IconSchool,
                            title: "Pendidikan",
                            link: "/admin/member-education",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Tempat Praktik",
                            link: "/practice",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "Pelatihan",
                            link: "/admin/member-training",
                          },
                          {
                            icon: PeopleIcon,
                            title: "Pengalaman Kerja",
                            link: "/admin/member-experience",
                          },
                          {
                            icon: StarsIcon,
                            title: "Penghargaan",
                            link: "/admin/member-appreciation",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: IconSchool,
                            title: "SKP",
                            link: "/admin-p2kb",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Serkom",
                            link: "/admin/serkom",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR",
                            link: "/admin/str",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR KT",
                            link: "/admin/strkt",
                          },
                          {
                            icon: PeopleIcon,
                            title: "SIP",
                            link: "/admin/sip",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="Trans/ Mutasi"
                        icon={PeopleAddIcon}
                        onClick={() => onItemClicked("Trans/ Mutasi")}
                        active={selectedItem === "Trans/ Mutasi"}
                        child={[
                          {
                            icon: PeopleAddIcon,
                            title: "Mutasi Anggota",
                            link: "/admin/mutation",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Trans RS",
                            link: "/transrs",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="Data Referensi"
                        icon={PreferenceIcon}
                        onClick={() => onItemClicked("Data Referensi")}
                        active={selectedItem === "Data Referensi"}
                        child={[
                          // {
                          //   icon: PeopleIcon,
                          //   title: "Pengguna",
                          //   link: "/pengguna",
                          // },
                          {
                            icon: IconSchool,
                            title: "Universitas",
                            link: "/universitas",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Rumah Sakit",
                            link: "/hospital",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "Subspesialis",
                            link: "/subspesialis",
                          },
                          {
                            icon: PeopleIcon,
                            title: "Ranah Kegiatan",
                            link: "/activity",
                          },
                          {
                            icon: StarsIcon,
                            title: "Cabang",
                            link: "/branch",
                          },
                          // {
                          //   icon: RedeemIcon,
                          //   title: "Benefit",
                          //   link: "/master-benefit",
                          // },
                        ]}
                      />
                      <MenuItemComponent
                        title="Media"
                        icon={DeviceIcon}
                        onClick={() => onItemClicked("Media")}
                        active={selectedItem === "Media"}
                        child={[
                          // {
                          //   icon: IconSchool,
                          //   title: "CMS",
                          //   link: "/dashboard-admin-pusat",
                          // },
                          {
                            icon: MailIcon,
                            title: "Message Blast",
                            link: "/message-blast",
                          },
                          {
                            icon: AdsIcon,
                            title: "Iklan",
                            link: "/iklan",
                          },
                        ]}
                      />
                      {/* <MenuItemComponent
                        title="Pembayaran"
                        icon={PaymentIcon}
                        onClick={() => onItemClicked("Pembayaran")}
                        active={selectedItem === "Pembayaran"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Iuran Paboi",
                            link: "/iuran",
                          },
                          {
                            icon: AccountBalanceIcon,
                            title: "Koperasi",
                            link: "/koperasi",
                          },
                          {
                            icon: RedeemIcon,
                            title: "Benefit",
                            link: "/benefit",
                          },
                          {
                            icon: PeopleIcon,
                            title: "PABOI Cabang",
                            link: "/education",
                          },
                        ]}
                      /> */}
                      <NavLink to="/event" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Event"
                          icon={EventIcon}
                          onClick={() => onItemClicked("Event")}
                          active={selectedItem === "Event"}
                        />
                      </NavLink>
                      {/* <NavLink to="/journal" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Journal"
                          icon={DocumentIcon}
                          onClick={() => onItemClicked("Journal")}
                          active={selectedItem === "Journal"}
                        />
                      </NavLink> */}
                      <NavLink
                        to="/admin/support"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Perlindungan Hukum"
                          icon={SupportIcon}
                          onClick={() => onItemClicked("Support")}
                          active={selectedItem === "Support"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Report"
                        icon={DocumentIcon}
                        onClick={() => onItemClicked("Report")}
                        active={selectedItem === "Report"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Master",
                            link: "/admin/report-master",
                          },
                          {
                            icon: MonetizationIcon,
                            title: "Iuran Paboi",
                            link: "/admin/iuran",
                          },
                          {
                            icon: AccountBalanceIcon,
                            title: "Koperasi",
                            link: "/admin/iuran-koperasi",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="System"
                        icon={ComputerIcon}
                        onClick={() => onItemClicked("System")}
                        active={selectedItem === "System"}
                        child={[
                          {
                            icon: PeopleIcon,
                            title: "Pengguna",
                            link: "/pengguna",
                          },
                          {
                            icon: DocumentIcon,
                            title: "Audit Trail",
                            link: "/audit-trail",
                          },
                        ]}
                      />
                    </>
                  )}

                  {role === "ketua_kolegium" && (
                    <>
                      <NavLink
                        to="/dashboard-admin-kolegium"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Dashboard"
                          icon={IconDashboard}
                          onClick={() =>
                            onItemClicked("Dashboard", "dashboard")
                          }
                          active={selectedItem === "Dashboard"}
                        />
                      </NavLink>
                      <NavLink
                        to="/registrasi"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Registrasi"
                          icon={PeopleAddIcon}
                          onClick={() => onItemClicked("Registrasi")}
                          active={selectedItem === "Registrasi"}
                        />
                      </NavLink>
                      <NavLink to="/ppds" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="PPDS"
                          icon={IconSchool}
                          onClick={() => onItemClicked("PPDS")}
                          active={selectedItem === "PPDS"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Member"
                        icon={IconAccountCircle}
                        onClick={() => onItemClicked("Member")}
                        active={selectedItem === "Member"}
                        child={[
                          {
                            icon: IconSchool,
                            title: "Pendidikan",
                            link: "/admin/member-education",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: AddBoxIcon,
                            title: "Serkom",
                            link: "admin/serkom",
                          },
                        ]}
                      />
                    </>
                  )}
                  {role === "admin_koperasi" && (
                    <>
                      <NavLink
                        to="/dashboard-admin-koperasi"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Dashboard"
                          icon={IconDashboard}
                          onClick={() =>
                            onItemClicked("Dashboard", "dashboard")
                          }
                          active={selectedItem === "Dashboard"}
                        />
                      </NavLink>
                      <NavLink
                        to="/koperasi/registrasi"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Manajemen Anggota"
                          icon={PeopleAddIcon}
                          onClick={() => onItemClicked("Registrasi")}
                          active={selectedItem === "Registrasi"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Manajemen Benefit"
                        icon={PaymentIcon}
                        onClick={() => onItemClicked("Manajemen Benefit")}
                        active={selectedItem === "Manajemen Benefit"}
                        child={[
                          {
                            icon: RedeemIcon,
                            title: "Data Master",
                            link: "/master-benefit",
                          },
                          {
                            icon: RedeemIcon,
                            title: "Benefit",
                            link: "/benefit",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="Report"
                        icon={DocumentIcon}
                        onClick={() => onItemClicked("Report")}
                        active={selectedItem === "Report"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Koperasi",
                            link: "/admin/iuran-koperasi",
                          },
                          /* {
                            icon: AccountBalanceIcon,
                            title: "SHU",
                            link: "/admin/shu",
                          }, */
                        ]}
                      />
                    </>
                  )}
                  {role === "bendahara_koperasi" && (
                    <>
                      <NavLink to="/benefit" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Benefit"
                          icon={RedeemIcon}
                          onClick={() => onItemClicked("Benefit", "Benefit")}
                          active={selectedItem === "Benefit"}
                        />
                      </NavLink>
                    </>
                  )}
                  {role === "ketua_koperasi" && (
                    <>
                      <NavLink to="/benefit" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Benefit"
                          icon={RedeemIcon}
                          onClick={() => onItemClicked("Benefit", "Benefit")}
                          active={selectedItem === "Benefit"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Report"
                        icon={DocumentIcon}
                        onClick={() => onItemClicked("Report")}
                        active={selectedItem === "Report"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Koperasi",
                            link: "/admin/iuran-koperasi",
                          },
                          /* {
                            icon: AccountBalanceIcon,
                            title: "SHU",
                            link: "/admin/shu",
                          }, */
                        ]}
                      />
                    </>
                  )}

                  {(role === "chief_editor" ||
                    role === "reviewer" ||
                    role === "editor" ||
                    role === "language_editor") && (
                    <>
                      <NavLink to="/journal" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Journal"
                          icon={DocumentIcon}
                          onClick={() => onItemClicked("Journal")}
                          active={selectedItem === "Journal"}
                        />
                      </NavLink>
                    </>
                  )}

                  {role === "cpd_cme" && (
                    <>
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: AddBoxIcon,
                            title: "SKP",
                            link: "/admin-p2kb",
                          },
                        ]}
                      />
                    </>
                  )}
                  {role === "PPDS" && (
                    <>
                      <MenuItemComponent
                        title="Manajemen PPDS"
                        icon={IconSchool}
                        onClick={() => onItemClicked("Manajemen PPDS")}
                        active={selectedItem === "Manajemen PPDS"}
                        child={[
                          {
                            icon: IconAccountCircle,
                            title: "Profile",
                            link: "/manajemen-ppds/member-profile",
                          },
                          {
                            icon: IconSchool,
                            title: "Pendidikan",
                            link: "/manajemen-ppds",
                          },
                        ]}
                      />
                    </>
                  )}
                  {role === "ketua_paboi_cabang" && (
                    <>
                      <NavLink
                        to="/dashboard-admin-cabang"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Dashboard"
                          icon={IconDashboard}
                          onClick={() =>
                            onItemClicked("Dashboard", "dashboard")
                          }
                          active={selectedItem === "Dashboard"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Member"
                        icon={IconAccountCircle}
                        onClick={() => onItemClicked("Member")}
                        active={selectedItem === "Member"}
                        child={[
                          {
                            icon: PeopleIcon,
                            title: "Profil",
                            link: "/member",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: AddBoxIcon,
                            title: "SKP",
                            link: "/admin-p2kb",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR",
                            link: "/admin/str",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR KT",
                            link: "/admin/strkt",
                          },
                          {
                            icon: PeopleIcon,
                            title: "SIP",
                            link: "/admin/sip",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="Trans/ Mutasi"
                        icon={PeopleAddIcon}
                        onClick={() => onItemClicked("Trans/ Mutasi")}
                        active={selectedItem === "Trans/ Mutasi"}
                        child={[
                          {
                            icon: PeopleAddIcon,
                            title: "Mutasi Anggota",
                            link: "/admin/mutation",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Trans RS",
                            link: "/transrs",
                          },
                        ]}
                      />
                      <NavLink
                        to="/verifikasi-sip"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Verifikasi SIP"
                          icon={IconMail}
                          onClick={() => onItemClicked("Verifikasi SIP")}
                          active={selectedItem === "Verifikasi SIP"}
                        />
                      </NavLink>
                      <NavLink
                        to="/admin/support"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Perlindungan Hukum"
                          icon={SupportIcon}
                          onClick={() => onItemClicked("Support")}
                          active={selectedItem === "Support"}
                        />
                      </NavLink>

                      <MenuItemComponent
                        title="Report"
                        icon={DocumentIcon}
                        onClick={() => onItemClicked("Report")}
                        active={selectedItem === "Report"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Iuran Paboi",
                            link: "/admin/iuran-cabang",
                          },
                          // {
                          //   icon: AccountBalanceIcon,
                          //   title: "Dana Cabang",
                          //   link: "/admin/transfer-cabang",
                          // },
                          // {
                          //   icon: AccountBalanceIcon,
                          //   title: "Transfer",
                          //   link: "/admin/transfer",
                          // },
                        ]}
                      />
                    </>
                  )}
                  {role === "ketua_paboi_pusat" && (
                    <>
                      <NavLink
                        to="/dashboard-admin-pusat"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Dashboard"
                          icon={IconDashboard}
                          onClick={() =>
                            onItemClicked("Dashboard", "dashboard")
                          }
                          active={selectedItem === "Dashboard"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: IconSchool,
                            title: "SKP",
                            link: "/admin-p2kb",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Serkom",
                            link: "/admin/serkom",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR",
                            link: "/admin/str",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR KT",
                            link: "/admin/strkt",
                          },
                          {
                            icon: PeopleIcon,
                            title: "SIP",
                            link: "/admin/sip",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="Trans/ Mutasi"
                        icon={PeopleAddIcon}
                        onClick={() => onItemClicked("Trans/ Mutasi")}
                        active={selectedItem === "Trans/ Mutasi"}
                        child={[
                          {
                            icon: PeopleAddIcon,
                            title: "Mutasi Anggota",
                            link: "/admin/mutation",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Trans RS",
                            link: "/transrs",
                          },
                        ]}
                      />
                      <NavLink to="/event" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Event"
                          icon={EventIcon}
                          onClick={() => onItemClicked("Event")}
                          active={selectedItem === "Event"}
                        />
                      </NavLink>
                      <NavLink
                        to="/admin/support"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Perlindungan Hukum"
                          icon={SupportIcon}
                          onClick={() => onItemClicked("Support")}
                          active={selectedItem === "Support"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Report"
                        icon={DocumentIcon}
                        onClick={() => onItemClicked("Report")}
                        active={selectedItem === "Report"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Iuran Paboi",
                            link: "/admin/iuran",
                          },
                          {
                            icon: AccountBalanceIcon,
                            title: "Koperasi",
                            link: "/admin/iuran-koperasi",
                          },
                        ]}
                      />
                    </>
                  )}
                  {role === "admin_paboi_cabang" && (
                    <>
                      <NavLink
                        to="/dashboard-admin-cabang"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Dashboard"
                          icon={IconDashboard}
                          onClick={() =>
                            onItemClicked("Dashboard", "dashboard")
                          }
                          active={selectedItem === "Dashboard"}
                        />
                      </NavLink>
                      <MenuItemComponent
                        title="Member"
                        icon={IconAccountCircle}
                        onClick={() => onItemClicked("Member")}
                        active={selectedItem === "Member"}
                        child={[
                          {
                            icon: PeopleIcon,
                            title: "Profil",
                            link: "/member",
                          },
                          {
                            icon: IconSchool,
                            title: "Pendidikan",
                            link: "/admin/member-education",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Tempat Praktik",
                            link: "/practice",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "Pelatihan",
                            link: "/admin/member-training",
                          },
                          {
                            icon: PeopleIcon,
                            title: "Pengalaman Kerja",
                            link: "/admin/member-experience",
                          },
                          {
                            icon: StarsIcon,
                            title: "Penghargaan",
                            link: "/admin/member-appreciation",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="P2KB"
                        icon={ChampIcon}
                        onClick={() => onItemClicked("P2KB")}
                        active={selectedItem === "P2KB"}
                        child={[
                          {
                            icon: AddBoxIcon,
                            title: "SKP",
                            link: "/admin-p2kb",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR",
                            link: "/admin/str",
                          },
                          {
                            icon: RecordVoiceOverIcon,
                            title: "STR KT",
                            link: "/admin/strkt",
                          },
                          {
                            icon: PeopleIcon,
                            title: "SIP",
                            link: "/admin/sip",
                          },
                        ]}
                      />
                      <MenuItemComponent
                        title="Trans/ Mutasi"
                        icon={PeopleAddIcon}
                        onClick={() => onItemClicked("Trans/ Mutasi")}
                        active={selectedItem === "Trans/ Mutasi"}
                        child={[
                          {
                            icon: PeopleAddIcon,
                            title: "Mutasi Anggota",
                            link: "/admin/mutation",
                          },
                          {
                            icon: AddBoxIcon,
                            title: "Trans RS",
                            link: "/transrs",
                          },
                        ]}
                      />
                      <NavLink to="/pengurus" exact className={css(styles.navlink)}>
                        <MenuItemComponent
                          title="Pengurus Cabang"
                          icon={PeopleIcon}
                          onClick={() => onItemClicked("Pengurus Cabang")}
                          active={selectedItem === "Pengurus Cabang"}
                        />
                      </NavLink>
                      <NavLink
                        to="/verifikasi-sip"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Verifikasi SIP"
                          icon={IconMail}
                          onClick={() => onItemClicked("Verifikasi SIP")}
                          active={selectedItem === "Verifikasi SIP"}
                        />
                      </NavLink>
                      <NavLink
                        to="/admin/support"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Perlindungan Hukum"
                          icon={SupportIcon}
                          onClick={() => onItemClicked("Support")}
                          active={selectedItem === "Support"}
                        />
                      </NavLink>

                      <MenuItemComponent
                        title="Report"
                        icon={DocumentIcon}
                        onClick={() => onItemClicked("Report")}
                        active={selectedItem === "Report"}
                        child={[
                          {
                            icon: MonetizationIcon,
                            title: "Iuran Paboi",
                            link: "/admin/iuran-cabang",
                          },
                          // {
                          //   icon: AccountBalanceIcon,
                          //   title: "Dana Cabang",
                          //   link: "/admin/transfer-cabang",
                          // },
                        ]}
                      />
                    </>
                  )}
                  {role === "sekretaris_depoi" && (
                    <>
                      <NavLink
                        to="/admin/support"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Perlindungan Hukum"
                          icon={SupportIcon}
                          onClick={() => onItemClicked("Support")}
                          active={selectedItem === "Support"}
                        />
                      </NavLink>
                    </>
                  )}
                  {role === "ketua_depoi" && (
                    <>
                      <NavLink
                        to="/admin/support"
                        exact
                        className={css(styles.navlink)}
                      >
                        <MenuItemComponent
                          title="Perlindungan Hukum"
                          icon={SupportIcon}
                          onClick={() => onItemClicked("Support")}
                          active={selectedItem === "Support"}
                        />
                      </NavLink>
                    </>
                  )}

                  {/* <NavLink to="/serkom" exact className={css(styles.navlink)}>
                    <MenuItemComponent
                      title="Serkom"
                      icon={IconCardMembership}
                      onClick={() => onItemClicked("Serkom")}
                      active={selectedItem === "Serkom"}
                    />
                  </NavLink>
                  <NavLink to="/universitas" exact className={css(styles.navlink)}>
                    <MenuItemComponent
                      title="Universitas"
                      icon={IconSchool}
                      onClick={() => onItemClicked("Universitas")}
                      active={selectedItem === "Universitas"}
                    />
                  </NavLink>
                  <NavLink to="/pengguna" exact className={css(styles.navlink)}>
                    <MenuItemComponent
                      title="Pengguna"
                      icon={IconAccountCircle}
                      onClick={() => onItemClicked("Pengguna")}
                      active={selectedItem === "Pengguna"}
                    />
                  </NavLink>
                  <NavLink to="/p2kb" exact className={css(styles.navlink)}>
                    <MenuItemComponent
                      title="P2KB"
                      icon={IconBook}
                      onClick={() => onItemClicked("P2KB")}
                      active={selectedItem === "P2KB"}
                    />
                  </NavLink>
                  <NavLink to="/Login" exact className={css(styles.navlink)}>
                    <MenuItemComponent
                      title="Logout"
                      icon={IconAccountCircle}
                      onClick={() => onItemClicked("Logout")}
                      active={selectedItem === "Logout"}
                    />
                  </NavLink> */}
                </Column>
  );
}
